<template>
  <div>
    <DataTablePaginated
        ref="table"
        class="ma-1"
        :headers="headers"
        disableSearch
        dependsOnProperty3="registrationPending"
        :iconTooltip="$t('buttons:edit')"
        :iconTooltip2="$t('buttons:delete')"
        :iconTooltip3="$t('settings/profile:customer.user-management.tooltips.send-reg-mail')"
        @updateTableData="updateTable"
        checkbox-on-property="main"
        checkbox-on-property2="active"
        sortBy="name"
        @cacheCommit="$store.commit('settings/userProfile/storeUsersOverviewSearch', $event)"
    />
  </div>
</template>

<script>
import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated";
import UsersService from '@/modules/core/services/users-service';
import DataUtils from "@/modules/core/services/data-utils";
import Utils from '@/modules/core/services/utils';
import Users from '@/modules/core/data/users';

export default {
  name: "UsersTab",
  props: {
    customerId: {
      type: String,
      default: '00000000-0000-0000-0000-000000000000',
    }

  },
  data() {
    return {
      edit: null,
      users: new Users()
    }
  },
  computed: {
    headers() {
      return [
        {text: "User-Name", value: 'username'},
        {text: "Main", value: 'checkbox', sortable: false},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:email'), value: 'email'},
        {text: this.$t('common:active'), value: 'checkbox2', sortable: true}, // can be sortable, since checkbox2 is mapped to active in users-service.js
        {text: "", value: "controls", sortable: false},
      ]
    }
  },
  components: {
    DataTablePaginated
  },
  methods: {
    updateTable(options) {
      let filter = {
        customer: [this.customerId]
      }
      this.$store.commit('settings/userProfile/storeUsersOverviewOptions', options);

      UsersService.readFilteredPaginatedWithPrivilegesFromAPI(
          options.page - 1,
          options.itemsPerPage,
          options.sortBy,
          options.sortDesc,
          filter,
          (resp) => {
            resp.data.content = DataUtils.parseDataToObjectArray(resp.data.content, Users);
            this.$refs.table.fillTableData(resp.data);
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:user')}))
            this.$logger.error(error);
          }
      );
    },
  }
}
</script>